import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'

import { useQuery } from '~/client/hooks/cqrpc'
import Heading from '~/client/components/Heading'
import SideNote from '~/client/components/SideNote'
import HistoryList from '~/client/components/HistoryList'

export const routeOptions = {
  mustBeUser: true
}

export default function HistoryPage() {
  return <Container>
    <Heading my={2} variant="main">History</Heading>
    <SideNote>
      Whenever your data is changed or supplemented, by yourself or by any third-party with which you share it, a record is kept in your history. This means there can never be any argument about your intentions for your data at any point in time.​
    </SideNote>
    <MyHistory/>
  </Container>
}

function MyHistory(){
  const { result: events = [], loading, error } = useQuery('events.getMine')
  return <HistoryList {...{loading, error, events}}/>
}
